var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['c-item-checkbox', _vm.column.size]},[_c('InputCheckbox',{attrs:{"value":_vm.checked},on:{"input":_vm.onChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }